import { styled } from '@mui/system';
import { Stack } from '@mui/material';

export const ContentsSection = styled(Stack)({
  height: '70vh',
  width: '100%',
});